import React from 'react';

export function Header({ pathname = window.location.pathname }: { pathname?: string }) {
  const isToolPage = pathname === '/songlength';

  return (
    <header
      className="min-h-[10vh] flex flex-col items-center justify-center px-4 sm:px-6 text-primary mb-4"
      itemScope
      itemType="http://schema.org/WPHeader"
      role="banner"
      aria-label="Site Header"
    >
      <h1
        className="text-2xl sm:text-4xl md:text-6xl font-bold font-display text-center floating-text"
        itemProp="headline"
        data-content-importance="high"
        data-semantic-type="main-title"
        aria-label="Marc Plotkin | Official Site"
      >
        {isToolPage ? (
          <a href="/" className="hover:text-primary-hover transition-colors duration-300">
            <span>marc plotkin...</span>
          </a>
        ) : (
          <>
            <span>marc plotkin...</span>
            <a href="/" className="hover:text-primary-hover transition-colors duration-300">
              <span>what's his deal?</span>
            </a>
          </>
        )}
      </h1>
    </header>
  );
}
